// @flow
import { get } from 'axios'
import { Metadata } from '../../services/metadata'

// list
export const UPDATE_TARGET_LIST = 'targets:updateTargetsList'
export type UPDATE_LIST_TARGETS_TYPE = {
  type: 'targets:updateTargetsList',
  payload: { targets: string[] }
}

export const updateTargetsList = (targets: string[]): UPDATE_LIST_TARGETS_TYPE => {

  // update target list metadata
  const { updateUserMetadata } = new Metadata()
  updateUserMetadata({ targets })

  return {
    type: UPDATE_TARGET_LIST,
    payload: { targets }
  }
}

// specific target
export const UPDATE_TARGET = 'targets:updateTarget'
export type UPDATE_TARGET_TYPE = {
  type: 'targets:updateTarget',
  payload: { target: string }
}

export const updateTarget = (target: string): UPDATE_TARGET_TYPE => ({
  type: UPDATE_TARGET,
  payload: { target }
})

// company
export const UPDATE_COMPANY = 'targets:companyData'
export type UPDATE_COMPANY_TYPE = {
  type: 'targets:companyData',
  payload: { company: Object }
}

export const updateCompany = (company: Object): UPDATE_COMPANY_TYPE => ({
  type: UPDATE_COMPANY,
  payload: { company }
})

// company list 
export const UPDATE_COMPANY_LIST = 'targets:companyDataList'
export type UPDATE_COMPANY_LIST_TYPE = {
  type: 'targets:companyDataList',
  payload: { company: Object }
}

export const updateCompanyList = (company: Object): UPDATE_COMPANY_LIST_TYPE => ({
  type: UPDATE_COMPANY_LIST,
  payload: { company }
})

// status
export const UPDATE_TARGET_STATUS = 'targets:updateTargetStatus'
export type UPDATE_TARGET_STATUS_TYPE = {
  type: 'targets:updateTargetStatus',
  payload: {
    isFetching: boolean,
    error: null | string
  }
}

export const updateTargetStatus = (isFetching: boolean, error: null | string): UPDATE_TARGET_STATUS_TYPE => ({
  type: UPDATE_TARGET_STATUS,
  payload: {
    isFetching,
    error
  }
})

// get Company Data
export const getCompanyData = (dispatch: Function, symbol: string) => {

  try {
    // set status fetching: true, error: null
    dispatch(updateTargetStatus(true, null))

    // get data from two sources
    Promise.all([
      get(`https://cloud.iexapis.com/v1/stock/${symbol}/company?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
      get(`https://cloud.iexapis.com/v1/stock/${symbol}/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)
    ]).then((res) => {
      if (res.length) {
        const data = [res[0].data, res[1].data]
        // create and dispatch company data
        const companyData: Object = {
          name: data[0].companyName,
          description: data[0].description,
          symbol: data[0].symbol,
          price: data[1].latestPrice,
          changeDollar: data[1].change,
          changePercent: data[1].changePercent
        }

        // set status fetching: false, error: null
        dispatch(updateTargetStatus(false, null))

        // update company data
        dispatch(updateCompany(companyData))
        dispatch(updateCompanyList(companyData))
      }
    }).catch(err => {

      // set status fetching: false, error: msg
      dispatch(updateTargetStatus(false, 'No Company Data'))
    })
  }
  catch(err) {}
}


// WEBPACK FOOTER //
// ./src/actions/targets/index.js